<template>
  <v-card>
      <v-toolbar>
        <v-toolbar-title>PO Cost</v-toolbar-title>
        <v-spacer />
        <AddPayment :poId="model.id" @add="addPayment($event)" />
      </v-toolbar>
      <v-simple-table>
          <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">
                        Type
                    </th>
                    <th class="text-left">
                        Amount
                    </th>
                    <th class="text-left">
                        Note
                    </th>
                    <th class="text-left">
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="payment in model.payments"
                    :key="'payment_'+payment.id"
                >
                <td>{{ payment.type }}</td>
                <td>{{ payment.amount }}</td>
                <td>{{ payment.note }}</td>
                <td>
                    <v-btn icon @click="deleteItem(payment)">
                        <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                </td>
                </tr>
            </tbody>
          </template>
      </v-simple-table>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import AddPayment from "./AddPayment.vue"
export default {
    components:{
        AddPayment
    },
    props:{
        value:{
            type:Object,
            required:true
        }
    },
    computed:{
        model:{
            get(){
                return this.value;
            },
            set(val){
                this.$emit('input',val);
            }
        }
    },
    methods:{
        ...mapActions("purchaseOrders", ["deletePayment"]),
        addPayment(payment){
            this.model.payments.push(payment);
        },
        deleteItem(payment){
            this.deletePayment(payment)
            .then(() => {
                this.model.payments = this.model.payments.filter(p => p.id !== payment.id);
            })
        }
    }
}
</script>

<style>

</style>